import React from 'react';
import { BookingButton } from './BookingButton';
interface FooterCTAProps {
  title?: string;
  subtitle?: string;
  buttonText?: string;
  buttonHref?: string;
}
export function FooterCTA({
  title = 'Afacerea ta merită să funcționeze fără ca tu să fii implicat personal în ea în fiecare zi.',
  subtitle = 'Rezervă acum o sesiune cadou de diagnostic și hai să vedem împreună ce oprește creșterea companiei tale și care e primul pas concret.',
  buttonText = 'Rezervă Sesiunea Cadou de Diagnoză',
  buttonHref = 'https://calendly.com/valerdura-coaching/sesiune-descoperire'
}: FooterCTAProps) {
  return <section className="w-full bg-[#0A1628] py-16 md:py-24 relative overflow-hidden" data-id="element-70">
      {/* Dramatic background effects */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#1D4ED8] opacity-[0.08] blur-[200px] rounded-full pointer-events-none" data-id="element-71"></div>
      <div className="absolute top-0 left-0 w-[400px] h-[400px] bg-[#3B82F6] opacity-[0.05] blur-[120px] rounded-full pointer-events-none" data-id="element-72"></div>
      <div className="absolute bottom-0 right-0 w-[400px] h-[400px] bg-[#1D4ED8] opacity-[0.05] blur-[120px] rounded-full pointer-events-none" data-id="element-73"></div>
      <div className="absolute inset-0 opacity-[0.03] bg-[radial-gradient(#ffffff_1px,transparent_1px)] [background-size:24px_24px]" data-id="element-74"></div>

      {/* Decorative corner accents */}
      <div className="absolute top-8 left-8 w-32 h-32 border-t-2 border-l-2 border-[rgba(59,130,246,0.2)] rounded-tl-3xl pointer-events-none" data-id="element-75"></div>
      <div className="absolute bottom-8 right-8 w-32 h-32 border-b-2 border-r-2 border-[rgba(59,130,246,0.2)] rounded-br-3xl pointer-events-none" data-id="element-76"></div>
      <div className="absolute top-8 right-8 w-16 h-16 border-t border-r border-[rgba(59,130,246,0.1)] rounded-tr-2xl pointer-events-none" data-id="element-77"></div>
      <div className="absolute bottom-8 left-8 w-16 h-16 border-b border-l border-[rgba(59,130,246,0.1)] rounded-bl-2xl pointer-events-none" data-id="element-78"></div>

      {/* Animated floating elements */}
      <div className="absolute top-[20%] left-[10%] w-2 h-2 bg-[#3B82F6] rounded-full opacity-40 animate-ping" style={{
      animationDuration: '3s'
    }} data-id="element-79"></div>
      <div className="absolute top-[30%] right-[15%] w-1.5 h-1.5 bg-[#1D4ED8] rounded-full opacity-30 animate-ping" style={{
      animationDuration: '4s'
    }} data-id="element-80"></div>
      <div className="absolute bottom-[25%] left-[20%] w-1 h-1 bg-[#3B82F6] rounded-full opacity-50 animate-ping" style={{
      animationDuration: '2.5s'
    }} data-id="element-81"></div>
      <div className="absolute bottom-[35%] right-[10%] w-2 h-2 bg-[#1D4ED8] rounded-full opacity-20 animate-ping" style={{
      animationDuration: '5s'
    }} data-id="element-82"></div>

      {/* Decorative rings */}
      <svg className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] pointer-events-none" viewBox="0 0 400 400" fill="none" data-id="element-83">
        <circle cx="200" cy="200" r="180" stroke="#1D4ED8" strokeWidth="0.5" opacity="0.1" strokeDasharray="4 6" data-id="element-84">
          <animateTransform attributeName="transform" type="rotate" from="0 200 200" to="360 200 200" dur="80s" repeatCount="indefinite" data-id="element-85" />
        </circle>
        <circle cx="200" cy="200" r="150" stroke="#3B82F6" strokeWidth="0.3" opacity="0.08" strokeDasharray="2 8" data-id="element-86">
          <animateTransform attributeName="transform" type="rotate" from="360 200 200" to="0 200 200" dur="60s" repeatCount="indefinite" data-id="element-87" />
        </circle>
      </svg>

      <div className="max-w-[900px] mx-auto px-5 md:px-12 text-center relative z-10" data-id="element-88">
        <div className="inline-flex items-center gap-2 bg-[rgba(29,78,216,0.15)] border border-[rgba(29,78,216,0.3)] px-5 py-2.5 rounded-full mb-10" data-id="element-89">
          <div className="w-2 h-2 rounded-full bg-[#3B82F6] animate-pulse" data-id="element-90"></div>
          <span className="font-['Montserrat'] text-[11px] font-bold tracking-[0.18em] uppercase text-[#3B82F6]" data-id="element-91">
            PRIMUL PAS SPRE LIBERTATE
          </span>
        </div>

        <h2 className="font-['Montserrat'] text-[clamp(28px,4vw,44px)] font-extrabold text-white mb-8 leading-[1.2] tracking-tight" data-id="element-92">
          {title}
        </h2>

        <p className="font-['Inter'] text-[19px] font-light text-[rgba(255,255,255,0.7)] leading-[1.8] mb-12 max-w-[640px] mx-auto" data-id="element-93">
          {subtitle}
        </p>

        <div className="relative inline-block mb-14" data-id="element-94">
          <div className="absolute inset-0 bg-[#1D4ED8] blur-[30px] opacity-40 rounded-2xl scale-110" data-id="element-95"></div>
          <BookingButton text={buttonText} href={buttonHref} className="relative z-10 px-12 py-6" data-id="element-96" />
        </div>

        {/* Trust row */}
        <div className="flex flex-wrap justify-center items-center gap-8 md:gap-12" data-id="element-97">
          <div className="flex items-center gap-2 text-[rgba(255,255,255,0.4)]" data-id="element-98">
            <svg className="w-5 h-5 text-[#3B82F6]" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-99">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-100" />
            </svg>
            <span className="font-['Inter'] text-[13px]" data-id="element-101">60 minute</span>
          </div>
          <div className="flex items-center gap-2 text-[rgba(255,255,255,0.4)]" data-id="element-102">
            <svg className="w-5 h-5 text-[#3B82F6]" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-103">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" data-id="element-104" />
            </svg>
            <span className="font-['Inter'] text-[13px]" data-id="element-105">100% Gratuit</span>
          </div>
          <div className="flex items-center gap-2 text-[rgba(255,255,255,0.4)]" data-id="element-106">
            <svg className="w-5 h-5 text-[#3B82F6]" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-107">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" data-id="element-108" />
            </svg>
            <span className="font-['Inter'] text-[13px]" data-id="element-109">Fără obligații</span>
          </div>
        </div>
      </div>
    </section>;
}